<template>
  <div>
    <div class="topbox">
      <el-input
        style="width: 100%"
        placeholder="请输运单号查询"
        v-model.trim="documentNumber"
        @keyup.native.enter="getData()"
        clearable
      >
        <template slot="append">
          <el-button class="topBtns" @click="getData()">查询</el-button>
        </template>
      </el-input>
    </div>

    <div class="block">
      <el-timeline>
        <el-timeline>
          <el-timeline-item
            v-for="(item, index) in TrackList"
            :key="index"
            :timestamp="item.title"
            placement="top"
            :color="item.color"
          >
            <el-card>
              <div class="line_cont">
                <aside>{{ item.content }}</aside>
                <div class="displayFlex">
                  <div v-if="item.expandFieldOne">
                    车牌号：{{ item.expandFieldOne || "" }}。
                  </div>
                  <div v-if="item.expandFieldTwo">
                    发出仓库：{{ item.expandFieldTwo || "" }}，
                  </div>
                  <div v-if="item.expandFieldThree">
                    目的地：{{ item.expandFieldThree || "" }}
                  </div>
                </div>
                <div class="trackImgsList">
                  <el-image
                    v-for="(itemA, idxA) in item.fileVoList"
                    :key="idxA"
                    class="trackImgs"
                    :src="itemA.fileUrl"
                    :preview-src-list="item.imgsList"
                  >
                  </el-image>
                </div>
                <section>{{ item.happenTime }}</section>
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </el-timeline>
    </div>
    <div class="nodata" v-if="TrackList.length == 0">暂无运单轨迹</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      TrackList: [],
      documentNumber: "",
    };
  },
  watch: {},
  created() {},
  mounted() {},
  activated() {
    let documentNumber = this.$route.query.waybillNumber || "";
    if (documentNumber) {
      this.documentNumber = documentNumber;
      this.getData();
    }
  },
  destroyed() {},
  methods: {
    getData() {
      if (!this.documentNumber) {
        this.$message.error("请输入运单号");
        return false;
      }
      this.$API
        .getWaybillTrackTransport({
          waybillNumber: this.documentNumber,
        })
        .then((res) => {
          // let arrs = res.data.result || [];
          // this.activities = arrs.reverse();
          // this.activities.forEach((item, index) => {
          //   item.color = "";
          //   if (index == 0) {
          //     item.color = "#0bbd87";
          //   }
          // });

          let arrs = res.data.result || [];
          let TrackList = arrs.reverse(); //翻转数组
          TrackList.forEach((item, index) => {
            item.color = "";
            if (index == 0) {
              item.color = "#0bbd87";
            }
            item.imgsList = [];
            if (item.fileVoList && item.fileVoList.length > 0) {
              item.fileVoList.forEach((itemA) => {
                item.imgsList.push(itemA.fileUrl);
              });
            }
          });

          this.TrackList = TrackList;
        });
    },
  },
};
</script>
<style scoped lang='less'>
.topbox {
  width: 360px;
  margin-bottom: 10px;
  .topBtns {
    background-color: #ef7c0a;
    color: #fff;
    padding: 7px 20px;
  }
}

.nodata {
  width: 100%;
  text-align: center;
  margin-top: 40vh;
  color: #999;
}

.trackImgsList {
  display: flex;

  .trackImgs {
    width: 60px;
    height: 60px;
    margin: 10px;
  }
}
</style>